const styles = () => ({
  grid: {
    marginBottom: '25px',
  },
});

export default styles;
